import React from "react";
import { cn } from "@/lib/utils";

/**
 * Generic shimmering loader block. Provide a className with width/height/rounded.
 */
export const Skeleton = ({ className }) => (
    <div className={cn("animate-pulse rounded-md bg-muted/80", className)} />
);

export const AvatarCardSkeleton = () => (
    <div className="space-y-3">
        <Skeleton className="aspect-square w-full rounded-2xl" />
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-3 w-full" />
    </div>
);
